import { Link } from 'react-router-dom';

export function Button({ children, to, variant = 'primary', className = '', loading = false, icon: Icon, ...props }) {
  const classes = `btn btn-${variant} ${className}`.trim();
  const content = (
    <>
      {Icon ? <Icon size={18} aria-hidden="true" /> : null}
      <span>{loading ? 'Please wait...' : children}</span>
    </>
  );

  if (to) {
    return <Link className={classes} to={to}>{content}</Link>;
  }

  return (
    <button className={classes} disabled={loading || props.disabled} {...props}>
      {content}
    </button>
  );
}
